<div [ngClass]="{ 'dark text-white-dark': store.semidark }">
    <nav class="sidebar fixed bottom-0 top-0 z-50 h-full min-h-screen w-[260px] shadow-[5px_0_25px_0_rgba(94,92,154,0.1)] transition-all duration-300">
        <div class="h-full bg-white dark:bg-[#0e1726]">
            <div class="flex items-center justify-between px-4 py-3">
                <a routerLink="/" class="main-logo flex shrink-0 items-center">
                    <img class="ml-[5px] w-[150px] flex-none" src="/assets/images/lamasLogo.svg" alt="" />
                </a>
                <a
                    href="javascript:;"
                    class="collapse-icon flex h-8 w-8 items-center rounded-full transition duration-300 hover:bg-gray-500/10 hover:text-primary dark:text-white-light dark:hover:bg-dark-light/10 rtl:rotate-180"
                    (click)="storeData.dispatch({ type: 'toggleSidebar'})"
                >
                    <icon-carets-down class="m-auto rotate-90" />
                </a>
            </div>
            
            <ng-scrollbar class="relative !h-[calc(100vh-80px)]" appearance="compact">
                <ul class="relative space-y-0.5 p-4 py-0 font-semibold">
                    
                    <!-- DASHBOARD Section -->
                    <ng-container>
                        <h2 class="-mx-4 mb-1 flex items-center bg-white-light/30 px-7 py-3 font-extrabold uppercase dark:bg-dark dark:bg-opacity-[0.08]">
                            <icon-minus class="hidden h-5 w-4 flex-none" />
                            <span>{{ ('tableau de bord' | translate) || '&nbsp;' }}</span>
                        </h2>

                        <li class="accordion menu nav-item">
                            <ul>
                                <li class="nav-item">
                                    <a
                                        routerLink="/"
                                        class="group"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{exact: true}"
                                        (click)="toggleMobileMenu()"
                                    >
                                        <div class="flex items-center">
                                            <icon-menu-dashboard class="shrink-0 group-hover:!text-primary" />
                                            <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">
                                                {{ 'Tableau de bord' | translate }}
                                            </span>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ng-container>

                    <!-- ADHERENT Section -->
                    <ng-container *ngIf="hasAdherentAccess()">
                        <h2 class="-mx-4 mb-1 flex items-center bg-white-light/30 px-7 py-3 font-extrabold uppercase dark:bg-dark dark:bg-opacity-[0.08]">
                            <icon-minus class="hidden h-5 w-4 flex-none" />
                            <span>{{ ('Adherent' | translate) || '&nbsp;' }}</span>
                        </h2>

                        <li class="accordion menu nav-item">
                            <ul>
                                <li class="nav-item" *ngIf="hasAccess('FDSA')">
                                    <a routerLink="/feuilles-de-soins/ADH" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                                        <div class="flex items-center">
                                            <icon-fds class="shrink-0 group-hover:!text-primary" />
                                            <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">
                                                {{ 'Soins ambulatoires' | translate }}
                                            </span>
                                        </div>
                                    </a>
                                </li>

                                <li class="nav-item" *ngIf="hasAccess('PECA')">
                                    <a routerLink="/prise-en-charge/ADH" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                                        <div class="flex items-center">
                                            <icon-pec class="shrink-0 group-hover:!text-primary" />
                                            <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">
                                                {{ 'Prise en charge' | translate }}
                                            </span>
                                        </div>
                                    </a>
                                </li>

                                <li class="nav-item" *ngIf="hasAccess('EPA')">
                                    <a routerLink="/ententes-prealables/ADH" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                                        <div class="flex items-center">
                                            <icon-ep  class="shrink-0 group-hover:!text-primary" />
                                            <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">
                                                {{ 'Ententes préalables' | translate }}
                                            </span>
                                        </div>
                                    </a>
                                </li>

                                <li class="nav-item" *ngIf="hasAccess('ALDA')">
                                    <a routerLink="/affection-longue-duree/ADH" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                                        <div class="flex items-center">
                                            <icon-ald class="shrink-0 group-hover:!text-primary" />
                                            <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">
                                                {{ 'Affections de longue durée' | translate }}
                                            </span>
                                        </div>
                                    </a>
                                </li>

                                <li class="nav-item" *ngIf="hasAccess('ADHA')">
                                    <a routerLink="/adhesion/ADH" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                                        <div class="flex items-center">
                                            <icon-adhesion class="shrink-0 group-hover:!text-primary" />
                                            <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">
                                                {{ 'Adhésion' | translate }}
                                            </span>
                                        </div>
                                    </a>
                                </li>

                                <li class="nav-item" *ngIf="hasAccess('RECA')">
                                    <a routerLink="/reclamations/ADH" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                                        <div class="flex items-center">
                                            <icon-reclamation class="shrink-0 group-hover:!text-primary" />
                                            <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">
                                                {{ 'Réclamations' | translate }}
                                            </span>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ng-container>

                    <!-- PARTENAIRE Section -->
                    <ng-container *ngIf="hasPartenaireAccess()">
                        <h2 class="-mx-4 mb-1 flex items-center bg-white-light/30 px-7 py-3 font-extrabold uppercase dark:bg-dark dark:bg-opacity-[0.08]">
                            <icon-minus class="hidden h-5 w-4 flex-none" />
                            <span>{{ ('Partenaire' | translate) || '&nbsp;' }}</span>
                        </h2>

                        <li class="accordion menu nav-item">
                            <ul>
                                <li class="nav-item" *ngIf="hasAccess('PECP')">
                                    <a routerLink="/prise-en-charge/PTR" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                                        <div class="flex items-center">
                                            <icon-pec class="shrink-0 group-hover:!text-primary" />
                                            <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">
                                                {{ 'Prise en charge' | translate }}
                                            </span>
                                        </div>
                                    </a>
                                </li>

                                <li class="nav-item" *ngIf="hasAccess('INFO')">
                                    <a routerLink="/adhesion/PTR" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                                        <div class="flex items-center">
                                            <icon-info-circle class="shrink-0 group-hover:!text-primary" />
                                            <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">
                                                {{ 'Information' | translate }}
                                            </span>
                                        </div>
                                    </a>
                                </li>

                                <li class="nav-item" *ngIf="hasAccess('RECP')">
                                    <a routerLink="/reclamations/PTR" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                                        <div class="flex items-center">
                                            <icon-reclamation class="shrink-0 group-hover:!text-primary" />
                                            <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">
                                                {{ 'Réclamations' | translate }}
                                            </span>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ng-container>

                    <!-- DOSSIERS HORS CASA Section -->
                    <ng-container *ngIf="hasAccess('DSHC')">
                        <h2 class="-mx-4 mb-1 flex items-center bg-white-light/30 px-7 py-3 font-extrabold uppercase dark:bg-dark dark:bg-opacity-[0.08]">
                            <icon-minus class="hidden h-5 w-4 flex-none" />
                            <span>{{ ('Dossiers hors casa' | translate) || '&nbsp;' }}</span>
                        </h2>

                        <li class="accordion menu nav-item">
                            <ul>
                                <li class="nav-item">
                                    <a routerLink="/dossier-hors-casa" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                                        <div class="flex items-center">
                                            <icon-box class="shrink-0 group-hover:!text-primary" />
                                            <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">
                                                {{ 'Dossiers hors casa' | translate }}
                                            </span>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ng-container>

                    <!-- CONFIGURATION Section -->
                    <ng-container *ngIf="isAdmin()">
                        <h2 class="-mx-4 mb-1 flex items-center bg-white-light/30 px-7 py-3 font-extrabold uppercase dark:bg-dark dark:bg-opacity-[0.08]">
                            <icon-minus class="hidden h-5 w-4 flex-none" />
                            <span>{{ ('Configuration' | translate) || '&nbsp;' }}</span>
                        </h2>

                        <ul>
                            <li class="nav-item" *ngIf="hasAccess('UTIL')">
                                <a routerLink="/utilisateurs" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                                    <div class="flex items-center">
                                        <icon-user-bo class="shrink-0 group-hover:!text-primary" />
                                        <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">
                                            {{ 'Utilisateurs' | translate }}
                                        </span>
                                    </div>
                                </a>
                            </li>
                            
                            <li class="nav-item" *ngIf="hasAccess('ADHP')">
                                <a routerLink="/adherents" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                                    <div class="flex items-center">
                                        <icon-adherent class="shrink-0 group-hover:!text-primary" />
                                        <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">
                                            {{ 'Adhérents' | translate }}
                                        </span>
                                    </div>
                                </a>
                            </li>
                            
                            <li class="nav-item" *ngIf="hasAccess('PART')">
                                <a routerLink="/partenaires" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                                    <div class="flex items-center">
                                        <icon-users class="shrink-0 group-hover:!text-primary" />
                                        <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">
                                            {{ 'Partenaires' | translate }}
                                        </span>
                                    </div>
                                </a>
                            </li>

                            <li class="nav-item" *ngIf="hasAccess('STAT')">
                                <a routerLink="/statistiques" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                                    <div class="flex items-center">
                                        <icon-menu-charts class="shrink-0 group-hover:!text-primary" />
                                        <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">
                                            {{ 'Statistiques' | translate }}
                                        </span>
                                    </div>
                                </a>
                            </li>
                            
                            <li class="nav-item" *ngIf="hasAccess('CONF')">
                                <a routerLink="/configuration/adherent" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                                    <div class="flex items-center">
                                        <icon-settings class="shrink-0 group-hover:!text-primary" />
                                        <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">
                                            {{ 'Configuration Adhérent' | translate }}
                                        </span>
                                    </div>
                                </a>
                            </li>
                            
                            <li class="nav-item" *ngIf="hasAccess('CONP')">
                                <a routerLink="/configuration/partenaire" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                                    <div class="flex items-center">
                                        <icon-settings class="shrink-0 group-hover:!text-primary" />
                                        <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">
                                            {{ 'Configuration Partenaire' | translate }}
                                        </span>
                                    </div>
                                </a>
                            </li>

                            <li class="nav-item" *ngIf="hasAccess('CONF')">
                                <a routerLink="/configuration/status" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                                    <div class="flex items-center">
                                        <icon-settings class="shrink-0 group-hover:!text-primary" />
                                        <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3">
                                            {{ 'Configuration Statuts' | translate }}
                                        </span>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </ng-container>

                    <!-- SESSION Section - Always visible -->
                    <h2 class="-mx-4 mb-1 flex items-center bg-white-light/30 px-7 py-3 font-extrabold uppercase dark:bg-dark dark:bg-opacity-[0.08]">
                        <icon-minus class="hidden h-5 w-4 flex-none" />
                        <span>{{ ('Session' | translate) || '&nbsp;' }}</span>
                    </h2>

                    <ul>
                        <li class="nav-item">
                            <a class="group cursor-pointer" (click)="logout()">
                                <div class="flex items-center">
                                    <icon-login class="shrink-0 group-hover:!text-primary" />
                                    <span class="text-red-500 dark:text-red-400 hover:text-red-700 dark:hover:text-red-500 ltr:pl-3 rtl:pr-3">
                                        {{ 'Se déconnecter' | translate }}
                                    </span>
                                </div>
                            </a>
                        </li>
                    </ul>
                </ul>
            </ng-scrollbar>
        </div>
    </nav>
</div>